(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Account', Account);

    Account.$inject = ['$resource','RESTHOST','RESTURIS'];

    function Account ($resource,RESTHOST,RESTURIS) {
        var service = $resource(RESTHOST.DATA_HOST+RESTURIS.ACCOUNT.RESOURCE, {}, {
            'get': { method: 'GET', params: {'pageSize':'10','pageIndex':'1'}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
